function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.82 3.35a2.55 2.55 0 00-.68-.8A3.69 3.69 0 004.2 2q-.5-.19-1-.35l-.79-.27a2.74 2.74 0 01-.66-.33 1.46 1.46 0 01-.43-.43A1.32 1.32 0 011.16 0 3.13 3.13 0 000 1.21a2.39 2.39 0 00.58.71 3.26 3.26 0 00.83.52 7.82 7.82 0 00.93.34l.9.3a3.43 3.43 0 01.76.37 1.67 1.67 0 01.5.55 1.38 1.38 0 01.19.75 1.49 1.49 0 01-.09.52 3.13 3.13 0 001.22-1.92z",
  fill: "#d2d2d2",
  className: "svg-no-adaptive-fill"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 5.82 5.22"
  }, props), _ref);
};

export default SvgComponent;